import React, { useState, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
//import { AllCommunityModules } from "@ag-grid-community/all-modules";
import { withRouter, Redirect } from "react-router-dom";
import MiniDrawer from "./../MiniDrawer";
import { Mixpanel } from "../mixpanel";
import { IonButton, IonPopover, IonGrid, IonRow, IonCol, IonLabel, IonTextarea, IonAlert, IonModal, IonItem, IonInput } from '@ionic/react';
import CloseIcon from '@material-ui/icons/Close';

// import "@ag-grid-community/all-modules/dist/styles/ag-grid.css";
// import "@ag-grid-community/all-modules/dist/styles/ag-theme-alpine.css";

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

import "./Page.css";
import "./../App.css";

import { getTimestamp } from "../components/timeStamp.js";
import { govHeadersJson } from "../services/hmrcGovHeaders.js";

import { useRecoilState } from "recoil";
import { userAtom, advisorAtom } from "../atom.js";
import { getLocalStorage } from "../components/localstorage.js";

// HMRC knownFact postcode: ^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$|BFPO\s?[0-9]{1,5}$
const normalizePostcodeForHmrc = (postcode) => {
  const trimmed = (postcode || "").trim().toUpperCase()
  if (!trimmed) return ""
  const compact = trimmed.replace(/\s+/g, "")
  if (/^BFPO\d{1,5}$/.test(compact)) {
    return compact.replace(/^(BFPO)(\d+)$/, "$1 $2")
  }
  if (/^[A-Z]{1,2}[0-9][0-9A-Z]?[0-9][A-Z]{2}$/.test(compact)) {
    return `${compact.slice(0, -3)} ${compact.slice(-3)}`
  }
  return trimmed
}

const Clients = (props) => {
  const [user_atom, setUserAtom] = useRecoilState(userAtom);
  const [advisor_atom, setAdvisorAtom] = useRecoilState(advisorAtom);
  const [recoilFetched, setRecoilFetched] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false)
  //const [gridColumnApi, setGridColumnApi] = useState(null);
  const [clientsRowData, setClientsRowData] = useState([]);
  const [connectingUser, setConnectingUser] = useState("")
  const [currentlyManaging, setCurrentlyManaging] = useState(false)
  const [ , setBase64] = useState("")
  const [confirmMessage, setConfirmMessage] = useState(false)
  const [delpopUpMessage, setDelpopUpMessage] = useState({

  })
  const [inviteUserId, setInviteUserId] = useState("")
  const [inviteClientName, setInviteClientName] = useState("")
  const [inviteClientEmail, setInviteClientEmail] = useState("")

  const [logout, setLogout] = useState(false)

  const [emailAlert, setEmailAlert] = useState(false)
  const [showInviteUrlModal, setShowInviteUrlModal] = useState(false)
  const [copySuccess, setCopySuccess] = useState(false)
  const [showTemplate, setShowTemplate] = useState(false)
  const [windowRef, setWindowRef] = useState([])
  const [newWindowRef, setNewWindowRef] = useState(null)
  const [relationshipResponse, setRelationshipResponse] = useState("")
  const [relationshipStatus, setRelationshipStatus] = useState(null)
  // const defaultMessage = <div style={{ width: "100%", overflowWrap: "break-word", wordWrap: "break-word" }}>
  //   <p>Hi</p>
  //   <p>Please add me as your advisor to untied - the UK’s personal tax app. I am using untied to help my clients stay on top of their taxes. With untied you can securely add your bank accounts to identify taxable transactions, automatically log business journeys, and share your data safely with me.</p>
  //   <p>Sign up or log on to untied using the following link:</p>
  //   <p>https://app.untied.io/login?target=transactions&agentCode={advisor_atom && advisor_atom.agent_code}</p>
  //   <p>If you already have an account with untied this link will add me as an advisor so that I can view/edit your data and submit tax returns on your behalf. If you do not already use untied this link will create a new untied account for you and assign me as an advisor at the same time.</p>
  //   <p>{advisor_atom && advisor_atom.agent_code}</p>
  //   <p>Kind regards,</p>
  //   <p></p>
  //   <p>{advisor_atom && advisor_atom.username}</p>
  // </div>

  const defaultTemplate = `Hi\n\nPlease add me as your advisor to untied - the UK’s personal tax app. I am using untied to help my clients stay on top of their taxes. With untied you can securely add your bank accounts to identify taxable transactions, automatically log business journeys, and share your data safely with me.\n\nSign up or log on to untied using the following link:\n\nhttps://app.untied.io/login?target=transactions&agentCode=${advisor_atom.agent_code}&email=[user_email]\n\nIf you already have an account with untied this link will add me as an advisor so that I can view/edit your data and submit tax returns on your behalf. If you do not already use untied this link will create a new untied account for you and assign me as an advisor at the same time.\n\n${advisor_atom.agent_code}\n\nKind regards,\n\n${advisor_atom.name}\n\n${advisor_atom.username}`
  var defaultBody = localStorage.getItem('email_template') 
  if (defaultBody === "null") {
    defaultBody = defaultTemplate
  }

  defaultBody = defaultBody.replace(/\[agent_code\]/g, advisor_atom.agent_code)
  defaultBody = defaultBody.replace(/\[agent_name\]/g, advisor_atom.name)
  defaultBody = defaultBody.replace(/\[agent_email\]/g, advisor_atom.username)

  //
  const [addClient, setAddClient] = useState(false)
  const emptyClientInfo = {
    email: "",
    oldEmail: "",
    emailBody: "",
    name: "",
    nin: "",
    utr: "",
    dob: "",
    postcode: ""
  }
  const [clientInfo, setClientInfo] = useState({
    ...emptyClientInfo
  })
  // const [userConnect, setUserConnect] = useState(false)

  const [gridApi, setGridApi] = useState(null);
  const [inviteUrl, setInviteUrl] = useState("")
  const urlLoginHandledRef = useRef(false)
  const urlInviteHandledRef = useRef(false)
  const isUserEmailRequired = (advisor_atom.user_email_required ?? 'Y') !== 'N'
  const requiresAcceptance = (advisor_atom.require_acceptance ?? 'Y') !== 'N'

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000); // Hide success message after 2 seconds
      console.log('URL copied to clipboard');
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
      console.log('URL copied to clipboard (fallback)');
    }
  }

  const parseRelationshipStatus = (json) => {

    if (json.status === "success" && json.info && json.info.status) {

      let result = { message: ""};
      if (json.info.result !== "") {
        result = JSON.parse(json.info.result);
      }
      const status = json.info.status;

      switch (status) {
        case 204:
          return {
            code: 204,
            message: "Agent is authorised to act for this client",
            type: "success"
          };
        case 403:
          return {
            code: 403,
            message: result.message || "The details provided for this client do not match HMRC's records",
            type: "warning"
          };
        case 404:
          return {
            code: 404,
            message: result.message || "Relationship is inactive. Agent is not authorised to act for this client",
            type: "danger"
          };
        default:
          return {
            code: status,
            message: `Error: Unexpected status code ${status}`,
            type: "danger"
          };
      }
    }
    return {
      code: null,
      message: "Error: Unable to check relationship status",
      type: "danger"
    };
  };

  const checkAgentUserRelationship = (userId) => {
    console.log('checking agent user relationship', userId)
    
    fetch('https://' + global.api_url + '/hmrc/checkAgentUserRelationship.php?userid='+ userId +'&ts=' + getTimestamp(), {
      method: "GET",
      headers: { token: advisor_atom.agentToken, agentId: advisor_atom.agent, govHeaders: govHeadersJson() }
    }).then(res => res.json())
      .then(json => {
        console.log('relationship check response:', json)
        setRelationshipResponse(JSON.stringify(json, null, 2))
        const parsedStatus = parseRelationshipStatus(json);
        setRelationshipStatus(parsedStatus);
      })
      .catch(error => {
        console.error('Error checking agent user relationship:', error);
        const errorResponse = { error: error.message };
        setRelationshipResponse(JSON.stringify(errorResponse, null, 2));
        setRelationshipStatus({
          code: null,
          message: `Error: ${error.message}`,
          type: "danger"
        });
      });
  }

  const agentInvite = (email, userId, name = "") => {
      console.log('agent invite', email, userId)
        
      fetch('https://' + global.api_url + '/hmrc/agentAuth.php?userid='+ userId +'&ts=' + getTimestamp(), {
        method: "GET",
        headers: { token: advisor_atom.agentToken, agentId: advisor_atom.agent, govHeaders: govHeadersJson() }
      }).then(res => res.json())
        .then(json => {
          console.log(json)
          if (json.status === "success" && json.url) {
            setInviteUrl(json.url)
            setInviteUserId(userId)
            setInviteClientEmail(email || "")
            setInviteClientName((name || "").trim())
            setRelationshipResponse("") // Clear previous response
            setRelationshipStatus(null) // Clear previous status
            // Also check the agent user relationship
            checkAgentUserRelationship(userId)
            setShowInviteUrlModal(true)
          }
        });
  }

  const cancelAgentAuth = (userId) => {
    console.log('cancel agent auth', userId)
    
    fetch('https://' + global.api_url + '/hmrc/cancelAgentAuth.php?userid='+ userId +'&ts=' + getTimestamp(), {
      method: "GET",
      headers: { token: advisor_atom.agentToken, agentId: advisor_atom.agent, govHeaders: govHeadersJson() }
    }).then(res => res.json())
      .then(json => {
        console.log(json)
        // Close the modal after canceling
        setShowInviteUrlModal(false);
        setInviteUrl("");
        setInviteUserId("");
        setInviteClientName("");
        setInviteClientEmail("");
        setRelationshipResponse("");
        setRelationshipStatus(null);
        setCopySuccess(false);
      })
      .catch(error => {
        console.error('Error canceling agent auth:', error);
        // Still close the modal even if there's an error
        setShowInviteUrlModal(false);
        setInviteUrl("");
        setInviteUserId("");
        setInviteClientName("");
        setInviteClientEmail("");
        setRelationshipResponse("");
        setRelationshipStatus(null);
        setCopySuccess(false);
      });
  }

  const connectUser = (userId) => {
    const user_info = advisor_atom.users.find((user) => {
      return user.id === userId
    })
    let advisor = advisor_atom
    setUserAtom({
      ...user_info,
      logged_in: true,
      agent: advisor.id
    })

    localStorage.setItem('guid', user_info.id);
    localStorage.setItem("token", user_info.token);
    localStorage.setItem("username", user_info.email);
    localStorage.setItem("mtd", user_info.mtd)
    localStorage.setItem("logged_in_as", user_info.email)
    setConnectingUser("")
    setPageLoaded(true)
    // localStorage.setItem("pingTime", new Date())
  }

  const constants = {
    defaultColDef: {
      resizable: true,
      editable: false,
      sortable: true,
      filter: true,
      floatingFilter: true,
      suppressMenu: true,
      flex: 1,
      minWidth: 100,
      suppressMovable: true,
      onCellDoubleClicked: (params) => {
        if (params.data.email) {
          if (params.data.status !== "pending") {
            setConnectingUser(params.data.id)
          }
          else {
            setClientInfo((prev) => ({ ...prev, email: params.data.email, oldEmail: params.data.email }))
            setAddClient(true)
          }
        }

      }
    },
    columnDefs: [
      {
        headerName: "Client name",
        field: "name",
        cellClass: "cell-style",
        filter: true,
      },
      // {
      //   headerName: "Type",
      //   field: "type",
      //   suppressMovable: false,
      //   cellClass: "cell-style"
      // },
      {
        headerName: "Email",
        field: "email",
        width: 200,
        cellClass: "cell-style",
        filter: true,        
      },
      {
        headerName: "Nino",
        field: "nin",
        width:50,
        cellClass: "cell-style",
        filter: true,
      },
      {
        headerName: "Postcode",
        field: "postcode",
        width: 50,
        cellClass: "cell-style",
        filter: true,
        cellRenderer: (params) => {
          //format the postcode nicely - upper case it - making sure it's not null first
          if (params.value) {
            return params.value.toUpperCase()
          }
        }
      },
      {
        headerName: "Status",
        field: "mtd",
        width: 150,
        maxWidth: 150,
        cellClass: "cell-style",
        filter: true,
        cellRenderer: (params) => {
          
          if (params.value === "N") {
            return ""
          }
          else if (params.value === "Y") {
            return "MTD Enabled"
          }
          else if (params.value === "S") {
            return "MTD Sandbox"
          }
          else if (params.data.status === "pending") {
            return 'Pending client confirmation'
          }
        }
      },

      // {
      //   headerName: "Pending",
      //   field: "pending",
      //   width: 110,
      //   cellClass: "cell-style",
      //   filter: changingPassword ? false : true,
      //   cellRenderer: (params) => {
      //     let status = "N"
      //     if (params.data.status == "pending"){
      //       status = "Y"
      //     }
      //     return status
      //   }
      // },
      {
        headerName: "Action",
        width: 150,
        maxWidth: 150, 
        filter: false,
        sortable: false,
        cellRendererFramework: function (params) {
          if (params.data.email) {
            if (params.data.status === "pending") {
              return (
                <button
                  onClick={() => {
                    setClientInfo((prev) => ({ ...prev, email: params.data.email }))
                    setAddClient(true)
                  }}
                >
                  {" "}
                  Send reminder{" "}
                </button>
              )
            }
            else {
              return (
                <>
                <button
                  onClick={() => {
                    setConnectingUser(params.data.id)
                  }}
                >
                  {" "}
                  Manage {" "}
                </button>{" "}
                <button
                  onClick={() => {
                    agentInvite(params.data.email, params.data.id, params.data.name)
                  }}
                >Invite</button>
                </>
              );
            }
          }
          else {
            return null
          }
        },
      },
      {
        headerName: "Remove client",
        cellClass: "cell-style",
        resizable: false,
        filter: false,
        maxWidth: 150,
        cellRenderer: (params) => {
          if (params.data.email) {
            const eDiv = document.createElement('div');
            const eSpan = document.createElement('span');
            eDiv.appendChild(eSpan)
            eDiv.className = "click-span"
            const eButton = document.createElement('button')
            eButton.className = "delete"
            eButton.addEventListener('click', () => {
              Mixpanel.track("delete_pay_request_clicked");
              setDelpopUpMessage({
                show: true,
                message: "Remove client",
                longMessage: `Are you sure you want to remove this client: ${params.data.email}?`,
                guid: params.data.id
              })
            });

            eSpan.appendChild(eButton)
            return eDiv
          }
          else {
            return null
          }
        }
      },
    ],
  };

  useEffect(() => {
    if (pageLoaded && JSON.stringify(user_atom) !== "{}") {
      if (localStorage.getItem("token")) {

        // get a short lived token from back end for this user by passing userId to /getShortLivedUsertoken.php
        // method is post. user_id is body parm. Pass agent token in 'token' header
        fetch('https://' + global.api_url + '/agent/getShortLivedUserToken.php?ts=' + getTimestamp(), {
          method: "POST",
          body: JSON.stringify({ user_id: user_atom.id }),
          headers: { token: advisor_atom.agentToken}
        }).then(res => res.json())
          .then(json => {
            if (json.status === "success") {

              let data = { token: json.token, agent_email: advisor_atom.username, agent_id: advisor_atom.agent}
              let base = btoa(JSON.stringify(data))
              setBase64(base)

              const portalUrl = window.location.href.includes("localhost")
                ? 'http://localhost:3000/login?data=' + base
                : `https://app.untied.io/login?data=${base}`

              // Use new window if available (from button click), else current window (e.g. URL-triggered when popup blocked)
              const targetWindow = newWindowRef && !newWindowRef.closed ? newWindowRef : window
              targetWindow.location = portalUrl

              if (newWindowRef && !newWindowRef.closed) {
                let windows = [...windowRef, newWindowRef]
                setWindowRef(windows)
              }
              setPageLoaded(false)

            }
          })
        
      }

    }
  }, [user_atom, advisor_atom, pageLoaded, windowRef, newWindowRef])

  useEffect(() => {
    if (connectingUser !== "" && JSON.stringify(advisor_atom) !== "{}") {
      if (!user_atom.logged_in || (user_atom.id.toString() === connectingUser)) {
        // connectUser(connectingUser)
        setConfirmMessage(true)
      }
      else {
        setCurrentlyManaging(true)
      }
    }
  },
    [connectingUser, advisor_atom, user_atom])

  useEffect(() => {
    if (windowRef.length > 0) {
      let windows = []
      
      windowRef.forEach(w => {
        windows.push(w)
      })
      
    }
  }, [windowRef])


  useEffect(() => {
    if (!recoilFetched) {
      let userState = getLocalStorage();
      if (!userState.agentToken) {
        
        setLogout(true)
      }
      else {
        if (localStorage.getItem("pingTime")) {
          let lastEvent = localStorage.getItem("pingTime")
          const nowTime = new Date();
          const thenTime = Date.parse(lastEvent);          
          const dif = nowTime - thenTime;
          const secondsElapsed = dif / 1000;
          
          if (secondsElapsed > 2700) {            
            setLogout(true)
          }
          else {
            if (userState.agentToken) {
              getUsers(userState, userState.agentToken)
              getCustomTags()
              setRecoilFetched(true);
            }
            else {              
              setLogout(true)
            }
          }
        } else {
          
          setLogout(true)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recoilFetched]);

  // URL handler: ?client_email=...&login=1 triggers "Log in as client" for that client (bypasses confirm popup)
  useEffect(() => {
    if (urlLoginHandledRef.current || !advisor_atom.users) return

    const params = new URLSearchParams(props.location.search)
    const clientEmail = params.get("client_email")
    const login = params.get("login")

    if (!clientEmail || login !== "1") return

    const user = advisor_atom.users.find(
      (u) => u.email && u.email.toLowerCase() === clientEmail.toLowerCase()
    )
    if (!user) return
    if (user.status === "pending") return // Only confirmed clients can be logged in as

    urlLoginHandledRef.current = true
    props.history.replace(props.location.pathname)

    // Open window before connectUser (may be null if popup blocked - pageLoaded useEffect will use current window as fallback)
    const ref = window.open("", "untiedUserPortal")
    setNewWindowRef(ref)
    connectUser(user.id)
  }, [advisor_atom.users, props.location.search, props.location.pathname, props.history]);

  // URL handler: ?client_email=...&invite=1 triggers Invite for that client
  useEffect(() => {
    if (urlInviteHandledRef.current || !advisor_atom.users) return

    const params = new URLSearchParams(props.location.search)
    const clientEmail = params.get("client_email")
    const invite = params.get("invite")

    if (!clientEmail || invite !== "1") return

    const user = advisor_atom.users.find(
      (u) => u.email && u.email.toLowerCase() === clientEmail.toLowerCase()
    )
    if (!user) return
    if (user.status === "pending") return // Only confirmed clients have Invite button

    urlInviteHandledRef.current = true
    props.history.replace(props.location.pathname)
    agentInvite(user.email, user.id, user.name)
  }, [advisor_atom.users, props.location.search, props.location.pathname, props.history]);

  const validateEmail = (email) => {
    // eslint-disable-next-line
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const discardClient = (requestId, token = advisor_atom.agentToken) => {

    fetch(`https://${global.api_url}/agent/removeUser.php?id=${requestId}&ts=${getTimestamp()}`,
      {
        method: "GET",
        headers: { token, partnerId: "775dbaef-6ac1-49a1-bfea-9ce82b8dbd2a" }
      }
    )
      .then(res => res.json())
      .then(json => {
        getUsers()
        setDelpopUpMessage({ show: false })
      });
  }

  const getUsers = (atom = advisor_atom, token = advisor_atom.agentToken) => {
    fetch(`https://${global.api_url}/agent/getUsers.php?ts=${getTimestamp()}`, {
      method: "GET",
      // body: body,
      headers: { token, partnerId: "775dbaef-6ac1-49a1-bfea-9ce82b8dbd2a" }
    })
      .then(res => res.json())
      .then(json => {
        
        if (json.status === "success") {
          let newAtom = { ...atom, users: json.users }
          setAdvisorAtom({ ...advisor_atom, ...newAtom })
          setClientsRowData([...json.users, {}]);
          if (gridApi) {
            gridApi.redrawRows();
          }
        }
        else {
          
          setLogout(true)
        }
      });
  }

  const getCustomTags = () => {
  
      const token = advisor_atom.agentToken
  
      console.log('get tags')
  
      fetch(`https://${global.api_url}/agent/getCustomTags.php?ts=${getTimestamp()}`,
        {
          method: "GET",
          headers: { token, partnerId: "775dbaef-6ac1-49a1-bfea-9ce82b8dbd2a" }
        })
        .then(res => res.json())
        .then(json => {
          // just calling this to make sure default custom tags are created ... 

        });
    }

  const sendEmail = (info) => {
    const email = (info.email || "").trim()
    const name = (info.name || "").trim()
    const needsEmail = isUserEmailRequired || requiresAcceptance
    if (!isUserEmailRequired && email === "" && name === "") {
      alert("Client name is required when email is not provided")
      return;
    }
    if (needsEmail && !validateEmail(email)) {
      setEmailAlert(true)
      return;
    }
    if (!needsEmail && email !== "" && !validateEmail(email)) {
      setEmailAlert(true)
      return;
    }

    const postcode = normalizePostcodeForHmrc(info.postcode)
    const payload = { ...info, email, name, postcode }
    if (payload.emailBody && email !== "") {
      payload.emailBody = payload.emailBody.replace(/\[user_email\]/g, email)
    }
    let body = JSON.stringify(payload)
    
    fetch(`https://${global.api_url}/agent/sendInvite.php?ts=${getTimestamp()}`, {
      method: "POST",
      body: body,
      headers: { token: advisor_atom.agentToken, partnerId: "775dbaef-6ac1-49a1-bfea-9ce82b8dbd2a" }
    })
      .then(res => res.json())
      .then(json => {
        if (json.status !== "success") {
          alert(json.message || "There was a problem adding this client")
          return
        }
        if (json.mode === "already_linked") {
          alert("Client with that name/email already exists and is already linked to this advisor")
          setAddClient(false)
          return
        }

        getUsers()
        if (json.mode === "provisioned") {
          alert("Client added successfully")
        }
        setAddClient(false)
      })
  }

  const services = {
    gridService: {
      onGridReady: (params) => {
        setGridApi(params.api);
        //setGridColumnApi(params.columnApi);
        params.api.sizeColumnsToFit();
      },
      onSelectionChanged: () => {
        let rowCount = gridApi.getSelectedRows().length;
        let showMultiList = false;
        let typeSelected = "";
        if (rowCount > 0) {
          const selectedGridRows = gridApi.getSelectedRows();
          typeSelected = selectedGridRows[0].type;
          selectedGridRows.forEach((element) => {
            if (!showMultiList) {
              showMultiList = element.type !== typeSelected;
            }
          });
        }
      },
    },
    renderService: {
      displayMainScreen: () => {

        if (logout) {
          localStorage.clear()
          return (
            <Redirect
              to={{
                pathname: "/logout",
              }}
            />
          )
        }

        if (recoilFetched) {

          return (<>
            <div
              style={{
                height: 48,
                flexDirection: "row",
                display: "flex",
                paddingLeft: 0,
                paddingBottom: 7
              }}
            >

              <IonButton
                className="ion-button-money"
                style={{ "--box-shadow": "none" }}
                onClick={() => {
                  setClientInfo({ ...emptyClientInfo, emailBody: requiresAcceptance ? defaultBody : "" })
                  setAddClient(true)
                }}
              >Add client
              </IonButton>
              <IonButton
                className="ion-button-money"
                style={{ "--box-shadow": "none" }}
                onClick={() => {
                  gridApi.deselectAll()
                  getUsers()
                }}
              >Refresh client list
              </IonButton>

            </div>
            <div className={`ag-theme-alpine grid-container ${1 === 2 ? "hide-grid" : "show-grid"}`}>
              <AgGridReact
                //modules={AllCommunityModules}
                defaultColDef={constants.defaultColDef}
                rowData={clientsRowData}
                columnDefs={constants.columnDefs}
                animateRows
                rowHeight={30}
                rowSelection={"multiple"}
                pagination={false}
                rowDeselection={true}
                suppressRowClickSelection={true}
                suppressDragLeaveHidesColumns={true}
                onSelectionChanged={() => services.gridService.onSelectionChanged()}
                onGridReady={services.gridService.onGridReady}
              />
            </div>
          </>)
        }
      },
      displayAddClientPopover: () => {
        return (<>
          <IonAlert
            isOpen={emailAlert}
            onDidDismiss={() => setEmailAlert(false)}
            header={"Invalid email"}
            // subHeader={error.errorSubTitle}
            message={"The email format provided is invalid, please check and retry"}
            buttons={['OK']}
          />
          <IonPopover
            isOpen={delpopUpMessage.show}
            onDidDismiss={() => setDelpopUpMessage({
              show: false,
              message: "",
              longMessage: "",
              guid: ""
            })}
            className="my-ion-client-popover"
          >

            <div style={{ textAlign: 'center' }}><h3>{delpopUpMessage.message}</h3></div>
            <div style={{ textAlign: 'center' }}>{delpopUpMessage.longMessage}</div>
            <IonGrid fixed={true} style={{ "--ion-grid-width-md": '600px', "--ion-grid-width-lg": '600px', "--ion-grid-width-xl": '600px' }}>


              <IonRow>
                <IonCol>
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <IonButton
                      className="ion-button-inverse"
                      onClick={() => {
                        setDelpopUpMessage({
                          show: false,
                          message: "",
                          longMessage: "",
                          guid: ""
                        })
                      }}
                    >
                      Cancel
                    </IonButton>
                  </div>
                </IonCol>
                <IonCol>
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <IonButton
                      className="ion-button-money"

                      onClick={() => {
                        discardClient(delpopUpMessage.guid)
                      }}
                    >
                      Remove
                    </IonButton>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonPopover>

          <IonPopover
            isOpen={currentlyManaging}
            onDidDismiss={() => {
              setConnectingUser("")
              setCurrentlyManaging(false)
            }}
            className="my-ion-client-popover"
          >
            <div style={{ textAlign: 'center' }}><h3>You are currently managing {user_atom.email}</h3></div>
            <div style={{ textAlign: 'center', margin: "10px" }}>Please click 'Log client out' to log out, make sure to close all open client tabs before managing another client</div>
            <IonGrid fixed={true} style={{ "--ion-grid-width-md": '600px', "--ion-grid-width-lg": '600px', "--ion-grid-width-xl": '600px' }}>
              <IonRow>
                <IonCol>
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <IonButton
                      className="ion-button-inverse"
                      onClick={() => {
                        setConnectingUser("")
                        setCurrentlyManaging(false)
                      }}
                    >
                      Cancel
                    </IonButton>
                  </div>
                </IonCol>
                <IonCol>
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <IonButton
                      className="ion-button-money"

                      onClick={() => {
                        localStorage.removeItem('guid');
                        localStorage.removeItem("token");
                        localStorage.removeItem("username");
                        localStorage.removeItem("mtd");
                        localStorage.removeItem("logged_in_as");
                        setUserAtom({})

                        setCurrentlyManaging(false);
                        windowRef.forEach(r => r.close())
                        setWindowRef([])
                        connectUser(connectingUser)

                      }
                      }
                    >
                      Log client out
                    </IonButton>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonPopover>

          <IonPopover
            isOpen={confirmMessage}
            onDidDismiss={() => {
              setConnectingUser("")
              setConfirmMessage(false)
            }}
            className="my-ion-client-popover"
          >
            <div style={{ textAlign: 'center' }}><h3>Logging in as client</h3></div>
            <div style={{ textAlign: 'center', margin: "10px" }}>To make sure there are no errors make sure any other instances of the untied app are closed in this browser</div>
            <IonGrid fixed={true} style={{ "--ion-grid-width-md": '600px', "--ion-grid-width-lg": '600px', "--ion-grid-width-xl": '600px' }}>
              <IonRow>
                <IonCol>
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <IonButton
                      className="ion-button-inverse"
                      onClick={() => {
                        setConnectingUser("")
                        setConfirmMessage(false)
                      }}
                    >
                      Cancel
                    </IonButton>
                  </div>
                </IonCol>
                <IonCol>
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <IonButton
                      className="ion-button-money"

                      onClick={() => {
                        // open a window NOW to avoid pop up blocker ... store the ref and use later when we know the URL to set to it
                        let ref = window.open('','untiedUserPortal');
                        setNewWindowRef(ref)

                        setConfirmMessage(false)
                        connectUser(connectingUser)
                      }
                      }
                    >
                      Log in as client
                    </IonButton>
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonPopover>



          <IonModal
            className="my-ion-client-popover"
            isOpen={addClient}
            style={{ height: "600px" }}
            onDidDismiss={() => {
              setClientInfo({ ...emptyClientInfo });
              setAddClient(false)
            }
            }

          >
            <div style={{ backgroundColor: "rgb(12, 144, 178)", width: "100%", height: "45px", display: "flex", flexDirection: "row" }}>
              <div style={{ paddingTop: "10px", color: "white", fontFamily: "Roboto, Helvetica, Arial, sans-serif", marginLeft: "10px", fontSize: "16px" }}>
                Add client
              </div>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", alignContents: "center", paddingRight: "10px", marginLeft: "auto" }}>
                <div style={{ alignSelf: "flex-end" }}>
                  <CloseIcon
                    style={{
                      height: 32,
                      color: "white",
                      width: "auto",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      setClientInfo({ ...emptyClientInfo });
                      setAddClient(false)
                    }}
                  /> </div>
              </div>
            </div>

            <div style={{ maxHeight: "70vh", whiteSpace: "nowrap", overflowY: "scroll", width: "900px" }}>
              <IonGrid fixed={true}
                style={{ "--ion-grid-width-md": '900px', "--ion-grid-width-lg": '900px', "--ion-grid-width-xl": '900px', "--ion-grid-height": "600px", backgroundColor: "rgba(132, 200, 217, 0.1)" }}
              >

           


                <IonRow>
                  <IonCol>
                    <IonLabel position="stacked">
                      Client email {isUserEmailRequired ? "" : "(optional)"}
                    </IonLabel>
                    <IonItem style={{
                      // border: "1px solid #3f90b0", borderRadius:"3px"
                    }}
                      lines="none"
                    >

                      <IonInput value={clientInfo.email}
                        placeholder={isUserEmailRequired ? "Client email" : "Client email (optional)"}
                        inputmode="text"
                        type="text"
                        // style = {{margin: "8px 0px 9px"}}
                        // position = "bottom"
                        onIonChange={e => {
                          setClientInfo({
                            ...clientInfo,
                            email: e.detail.value
                          })
                        }}
                      />
                    </IonItem >
                  </IonCol>
                </IonRow>

                <IonRow>
                  <IonCol>
                    <IonLabel position="stacked">Client name {!isUserEmailRequired ? "(required if no email)" : "(optional)"}</IonLabel>
                    <IonItem lines="none">
                      <IonInput
                        value={clientInfo.name}
                        placeholder="Client name"
                        inputmode="text"
                        type="text"
                        onIonChange={e => {
                          setClientInfo({
                            ...clientInfo,
                            name: e.detail.value || ""
                          })
                        }}
                      />
                    </IonItem>
                  </IonCol>
                </IonRow>

                <IonRow>
                  <IonCol>
                    <IonLabel position="stacked">NINO (optional)</IonLabel>
                    <IonItem lines="none">
                      <IonInput
                        value={clientInfo.nin}
                        placeholder="AB123456C"
                        inputmode="text"
                        type="text"
                        onIonChange={e => {
                          setClientInfo({
                            ...clientInfo,
                            nin: e.detail.value || ""
                          })
                        }}
                      />
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonLabel position="stacked">UTR (optional)</IonLabel>
                    <IonItem lines="none">
                      <IonInput
                        value={clientInfo.utr}
                        placeholder="1234567890"
                        inputmode="text"
                        type="text"
                        onIonChange={e => {
                          setClientInfo({
                            ...clientInfo,
                            utr: e.detail.value || ""
                          })
                        }}
                      />
                    </IonItem>
                  </IonCol>
                </IonRow>

                <IonRow>
                  <IonCol>
                    <IonLabel position="stacked">DOB (optional)</IonLabel>
                    <IonItem lines="none">
                      <IonInput
                        value={clientInfo.dob}
                        placeholder="YYYY-MM-DD"
                        inputmode="text"
                        type="date"
                        onIonChange={e => {
                          setClientInfo({
                            ...clientInfo,
                            dob: e.detail.value || ""
                          })
                        }}
                      />
                    </IonItem>
                  </IonCol>
                  <IonCol>
                    <IonLabel position="stacked">Postcode (optional)</IonLabel>
                    <IonItem lines="none">
                      <IonInput
                        value={clientInfo.postcode}
                        placeholder="SW1A 1AA"
                        inputmode="text"
                        type="text"
                        onIonChange={e => {
                          setClientInfo({
                            ...clientInfo,
                            postcode: e.detail.value || ""
                          })
                        }}
                      />
                    </IonItem>
                  </IonCol>
                </IonRow>

                {/* <IonRow>
                    <IonCol>
                    <IonItem>
                    <IonLabel position="floating" className="no-margin-bottom">Message for client</IonLabel>
                          <IonTextarea 
                          rows ={3}
                          type = "text"
                          placeholder = "Enter message to client"
                          inputmode="text"
                          autoGrow={true}
                          value = {clientInfo.message}
                          onIonChange={e=> {
                            setClientInfo({
                              ...clientInfo,
                              message: e.detail.value,
                            })
                          }}
                          >

                          </IonTextarea>
                    </IonItem>
                    </IonCol>
                  </IonRow> */}

                {requiresAcceptance && <IonRow >
                  <IonCol>
                    <IonLabel position="stacked" >Email contents</IonLabel>
                    <IonTextarea

                      type="text"
                      placeholder="Enter message to client"
                      inputmode="text"
                      autoGrow={true}
                      style={{
                        // border: "1px solid #3f90b0", borderRadius:"3px", padding: 5, 
                        backgroundColor: "rgb(255,255,255)"
                      }}
                      value={clientInfo.emailBody}
                      onIonChange={e => {
                        setClientInfo({
                          ...clientInfo,
                          emailBody: e.detail.value,
                        })
                      }}
                    >

                    </IonTextarea>
                  </IonCol>

                  {/* <h3 style = {{margin: 0, paddingLeft: 10}}>Email template</h3>
                      <div style ={{margin: "10px", padding: "5px",  backgroundColor: "rgb(225,225,225)", borderRadius:"3px", width: "100%", paddingBottom: "10px"}}>
                      {clientInfo.emailBody}
                    </div> */}
                </IonRow>}
                {requiresAcceptance && showTemplate && <IonRow style={{ width: "100%" }}>
                  <IonCol >
                    {/* <div style ={{ width: "800px", height: "fit-content",  whiteSpace: "nowrap"}}>
                        {defaultMessage}
                        </div> */}
                    <IonTextarea
                      rows={8}
                      type="text"
                      inputmode="text"
                      autoGrow={true}
                      disabled={true}
                      style={{
                        // border: "1px solid #3f90b0", borderRadius:"3px", padding: 5, 
                        backgroundColor: "rgb(255,255,255)", color: "black"
                      }}
                      value={defaultBody}
                    >

                    </IonTextarea>

                  </IonCol>
                </IonRow>}
              </IonGrid>
            </div>

            <IonGrid fixed={true}
              style={{ "--ion-grid-width-md": '900px', "--ion-grid-width-lg": '900px', "--ion-grid-width-xl": '900px', backgroundColor: "rgba(132, 200, 217, 0.1)" }}
            >
              <IonRow>
                <IonCol>
                  <IonButton
                    className="ion-button-inverse"
                    onClick={() => {

                      setAddClient(false)
                    }}
                  >
                    Cancel
                  </IonButton>

                </IonCol>

                {requiresAcceptance && <IonCol>
                  <IonButton
                    className="ion-button-money"
                    style={{ width: 150 }}
                    onClick={() => {
                      setShowTemplate(!showTemplate)
                    }}
                  >
                    {showTemplate ? "Hide template" : "Show template"}
                  </IonButton>
                </IonCol>}
                <IonCol>
                  <IonButton
                    className="ion-button-money"
                    onClick={() => {
                      sendEmail(clientInfo)
                      // let client = {
                      //     ...clientInfo, 
                      //     mtd: "N",
                      //     pending: true
                      //   }

                    }}
                  >
                    {requiresAcceptance ? "Send invite to client" : "Add client"}
                  </IonButton>

                </IonCol>

              </IonRow>

            </IonGrid>


          </IonModal>

          <IonModal
            className="my-ion-client-popover"
            isOpen={showInviteUrlModal}
            style={{ height: "600px" }}
            onDidDismiss={() => {
              setShowInviteUrlModal(false);
              setInviteUrl("");
              setInviteUserId("");
              setInviteClientName("");
              setInviteClientEmail("");
              setRelationshipResponse("");
              setRelationshipStatus(null);
              setCopySuccess(false);
            }}
          >
            <div style={{ backgroundColor: "rgb(12, 144, 178)", width: "100%", height: "45px", display: "flex", flexDirection: "row" }}>
              <div style={{ paddingTop: "10px", color: "white", fontFamily: "Roboto, Helvetica, Arial, sans-serif", marginLeft: "10px", fontSize: "16px" }}>
                HMRC Invite URL
              </div>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", alignContents: "center", paddingRight: "10px", marginLeft: "auto" }}>
                <div style={{ alignSelf: "flex-end" }}>
                  <CloseIcon
                    style={{
                      height: 32,
                      color: "white",
                      width: "auto",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      setShowInviteUrlModal(false);
                      setInviteUrl("");
                      setInviteUserId("");
                      setInviteClientName("");
                      setInviteClientEmail("");
                      setRelationshipResponse("");
                      setRelationshipStatus(null);
                      setCopySuccess(false);
                    }}
                  />
                </div>
              </div>
            </div>

            <div style={{ padding: "20px", backgroundColor: "rgba(132, 200, 217, 0.1)", height: "calc(100% - 45px)" }}>
              <IonGrid fixed={true} style={{ "--ion-grid-width-md": '600px', "--ion-grid-width-lg": '600px', "--ion-grid-width-xl": '600px', height: "100%" }}>
                <IonRow>
                  <IonCol>
                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                      <h3>HMRC Authorization URL Generated</h3>
                      {(inviteClientName || inviteClientEmail) && (
                        <div
                          style={{
                            marginBottom: "12px",
                            padding: "10px 14px",
                            backgroundColor: "rgba(12, 144, 178, 0.12)",
                            borderRadius: "8px",
                            border: "1px solid rgba(12, 144, 178, 0.35)",
                            fontSize: "15px",
                            lineHeight: 1.5,
                            textAlign: "center",
                          }}
                        >
                          {inviteClientName ? (
                            <div style={{ fontWeight: 600 }}>{inviteClientName}</div>
                          ) : null}
                          {inviteClientEmail ? (
                            <div style={{ color: "#333", wordBreak: "break-all" }}>{inviteClientEmail}</div>
                          ) : null}
                        </div>
                      )}
                      <p>Share this URL with your client to authorize HMRC access:</p>
                    </div>
                  </IonCol>
                </IonRow>

                <IonRow>
                  <IonCol>
                    <IonItem style={{ backgroundColor: "white", borderRadius: "5px", marginBottom: "20px" }}>
                      <IonTextarea
                        readonly={true}
                        value={inviteUrl}
                        rows={4}
                        style={{ 
                          fontSize: "14px", 
                          lineHeight: "1.4",
                          wordBreak: "break-all",
                          whiteSpace: "pre-wrap"
                        }}
                      />
                    </IonItem>
                  </IonCol>
                </IonRow>

                <IonRow>
                  <IonCol>
                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                      <h4>Agent User Relationship Status</h4>
                      {relationshipStatus ? (
                        <div 
                          style={{
                            display: 'inline-block',
                            padding: '10px 20px',
                            borderRadius: '8px',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            backgroundColor: 
                              relationshipStatus.type === 'success' ? '#d4edda' :
                              relationshipStatus.type === 'warning' ? '#fff3cd' : '#f8d7da',
                            color: 
                              relationshipStatus.type === 'success' ? '#155724' :
                              relationshipStatus.type === 'warning' ? '#856404' : '#721c24',
                            border: `1px solid ${
                              relationshipStatus.type === 'success' ? '#c3e6cb' :
                              relationshipStatus.type === 'warning' ? '#ffeaa7' : '#f5c6cb'
                            }`
                          }}
                        >
                          {relationshipStatus.code && `[${relationshipStatus.code}] `}
                          {relationshipStatus.message}
                        </div>
                      ) : (
                        <div 
                          style={{
                            display: 'inline-block',
                            padding: '10px 20px',
                            borderRadius: '8px',
                            fontStyle: 'italic',
                            backgroundColor: '#f8f9fa',
                            color: '#6c757d',
                            border: '1px solid #dee2e6'
                          }}
                        >
                          Loading relationship status...
                        </div>
                      )}
                    </div>
                  </IonCol>
                </IonRow>

                <IonRow>
                  <IonCol>
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", alignItems: "center" }}>
                      <IonButton
                        className="ion-button-money"
                        onClick={() => copyToClipboard(inviteUrl)}
                      >
                        Copy to Clipboard
                      </IonButton>
                      {copySuccess && (
                        <span style={{ color: "green", fontWeight: "bold", marginLeft: "10px" }}>
                          ✓ Copied!
                        </span>
                      )}
                      {inviteUrl !== "ALREADY_AUTHORISED" && (
                        <IonButton
                          className="ion-button-inverse"
                          onClick={() => cancelAgentAuth(inviteUserId)}
                        >
                          Cancel Auth
                        </IonButton>
                      )}
                      <IonButton
                        className="ion-button-inverse"
                        onClick={() => {
                          setShowInviteUrlModal(false);
                          setInviteUrl("");
                          setInviteUserId("");
                          setInviteClientName("");
                          setInviteClientEmail("");
                          setRelationshipResponse("");
                          setRelationshipStatus(null);
                          setCopySuccess(false);
                        }}
                      >
                        Close
                      </IonButton>
                    </div>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </div>
          </IonModal></>)
      },

      // displayFooter: () => {
      //   return <Footer />;
      // },
    },
  };

  return (<>
    {/* {base64!=="" && redirectWindow()} */}
    <React.Fragment>
      <div className="accounts-page-container">
        <MiniDrawer code={advisor_atom.agent_code} />
        <div className="accounts-page-content">
          {services.renderService.displayAddClientPopover()}
          {services.renderService.displayMainScreen()}
          {/* {services.renderService.displayFooter()} */}
        </div>
      </div>
    </React.Fragment>
  </>);
};

export default withRouter(Clients);